(function () {
    if (!document.querySelector('media-gallery')) {
        return;
    }

    if (window.mobileGalleryFixLoaded) {
        return;
    }

    window.mobileGalleryFixLoaded = true;

    const mainSlides = document.querySelectorAll('.product__media-list .product__media-item');
    const thumbnails = document.querySelectorAll('.thumbnail-list__item button');

    if (!mainSlides.length || !thumbnails.length) {
        return;
    }

    mainSlides.forEach(function (slide) {
        if (!slide.classList.contains('is-active')) {
            slide.style.display = 'none';
        }
    });

    thumbnails.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const targetId = this.closest('li')?.dataset.target;

            if (!targetId) {
                return;
            }

            const targetSlide = document.querySelector(
                '.product__media-list [data-media-id="' + targetId + '"]'
            );

            if (!targetSlide) {
                return;
            }

            mainSlides.forEach(function (slide) {
                slide.style.display = 'none';
                slide.classList.remove('is-active');
            });

            targetSlide.style.display = '';
            targetSlide.classList.add('is-active');

            thumbnails.forEach(function (thumb) {
                thumb.setAttribute('aria-current', 'false');
            });

            button.setAttribute('aria-current', 'true');
        });
    });
})();